import React, { useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    houseName: '',
    loading: false,
}

const EditHouse = ({houseInfo}) => {

    const [currentNotify, setNotify] = useState(null);
    const {getHouses } = useConfig();
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        getHouses();
    }, [])

    useEffect(()=>{
        if(houseInfo){
            dispatch({type: 'houseName', value: houseInfo.house});
        }
    }, [houseInfo]);

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }

        if(state.houseName.length === 0){
            setNotify(<Notification type='danger' message="Please enter house name"/>);
            return;
        }

        dispatch({type: 'loading', value: true});
        const server_response = await ajaxConfig.updateHouse(houseInfo.house_id, state.houseName);
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            getHouses(true);
           
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);

        }

    }


     
  

    return (
        <div className="card-body">

            <CallOut 
                title="School House"
                description="Edit the details of the school house. You can change the name of the house and save your changes."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                <TextInput
                    type="text"
                    label="House Name"
                    placeholder="House Name"
                    leftIcon="fa fa-home"
                    value={state.houseName}
                    onChange={e => dispatch({type: 'houseName', value: e.target.value})}
                    required
                    wrap
                    />

                

                    <div className="text-right">
                        {!state.loading && <button type="submit" className="btn btn-lg btn-primary">Save Changes</button>}
                        {state.loading && <ActivityLoader />}
                    </div>

            </form> 


        </div>
    );
};

export default EditHouse;